export default __webpack_public_path__ + "static/media/rodentia-icons_ok.eeb06aaa.svg";